import { useSettings } from './settings';
import React, { createContext, useContext, useEffect, useState } from "react";

const translations = {
  az: {
    nav: { home: "Ana səhifə", catalog: "Məhsullar", pdfs: "PDF Kataloqlar", contact: "Əlaqə", admin: "Admin" },
    hero: {
      eyebrow: "Friend Doors — Premium Qapılar",
      title: "Səliqəli forma. Sağlam qapı.",
      subtitle: "Giriş, otaq və ofis qapılarının minimalist kolleksiyası. Hər qapı fərdi ölçü və material seçimi ilə hazırlanır.",
      cta_primary: "Kataloqa bax",
      cta_secondary: "PDF Kataloqları yüklə",
    },
    home: {
      featured: "Seçilmiş qapılar",
      all_products: "Bütün məhsullar",
      about_label: "Haqqımızda",
      about_title: "Səssiz forma, dəqiq icra",
      about_body: "Friend Doors — arxitektura zövqünə uyğun, uzun ömürlü qapılar istehsalçısıdır. Hər model əl işi ilə tamamlanır və detallara ciddi diqqət ayrılır.",
      stats: [
        { k: "12+", v: "İllik təcrübə" },
        { k: "3000+", v: "Quraşdırılmış qapı" },
        { k: "48 saat", v: "Orta çatdırılma müddəti" },
      ],
      cta_title: "Sizə uyğun qapı axtarırsınız?",
      cta_body: "Kataloqumuza baxın və ya PDF broşürlərimizi endirin.",
    },
    catalog: {
      title: "Məhsullar",
      subtitle: "Kolleksiyamızdakı bütün modellər.",
      filter: "Filtr",
      all: "Hamısı",
      empty: "Hazırda məhsul yoxdur.",
      view: "Ətraflı",
      price_from: "Qiymət",
    },
    door: {
      material: "Material",
      dimensions: "Ölçülər",
      colors: "Rənglər",
      category: "Kateqoriya",
      order: "Sifariş üçün əlaqə",
      back: "← Geri",
    },
    categories: { all: "Hamısı", entrance: "Giriş qapıları", interior: "Otaq qapıları", bathroom: "Hamam qapıları", office: "Ofis qapıları" },
    pdfs: {
      title: "PDF Kataloqlar",
      subtitle: "Bütün kataloqlarımızı brauzerdə baxın və ya endirin.",
      preview: "Bax",
      fullscreen: "Tam ekran",
      download: "Endir",
      open_note: "Yükləmədən birbaşa baxın",
      empty: "Hazırda PDF kataloq yoxdur.",
      close: "Bağla",
    },
    admin: {
      login_title: "Admin girişi",
      email: "Email",
      password: "Parol",
      login: "Giriş",
      dashboard: "İdarə paneli",
      logout: "Çıxış",
      doors_tab: "Qapılar",
      catalogs_tab: "PDF Kataloqlar",
      add_door: "Yeni qapı əlavə et",
      edit_door: "Qapını düzəlt",
      add_catalog: "Yeni PDF əlavə et",
      name: "Ad",
      description: "Təsvir",
      price: "Qiymət (AZN)",
      category: "Kateqoriya",
      material: "Material",
      dimensions: "Ölçülər (məs. 90x210 sm)",
      colors: "Rənglər (vergüllə ayır)",
      image: "Şəkil",
      upload: "Yüklə",
      save: "Yadda saxla",
      cancel: "Ləğv et",
      delete: "Sil",
      edit: "Düzəlt",
      confirm_delete: "Silmək istədiyinizə əminsiniz?",
      title_field: "Başlıq",
      pdf_file: "PDF fayl",
      cover_image: "Qapaq şəkli",
      cover_help: "İstəyə bağlı. Yükləsəniz, PDF önizləməsi əvəzinə bu şəkil qapaq kimi göstərilər.",
      remove: "Sil",
      edit: "Redaktə et",
      no_items: "Element yoxdur",
      hero_tab: "Hero media",
      hero_title_section: "Ana səhifə hero şəkli və videosu",
      hero_help: "Şəkil və video yükləyin. Video varsa, o oynadılacaq (səssiz, avtomatik, təkrarlanan). Yoxdursa şəkil göstəriləcək.",
      hero_image: "Hero şəkli",
      hero_video: "Hero videosu",
      upload_image: "Şəkil yüklə",
      upload_video: "Video yüklə",
      no_image: "Şəkil yoxdur",
      no_video: "Video yoxdur",
      hero_video_note: "MP4 tövsiyə olunur. Ölçünü kiçik saxlayın (ideal < 20 MB, 10-15 saniyə loop).",
      uploaded: "Yükləndi",
      saved: "Yadda saxlandı",
      deleted: "Silindi",
      upload_pdf_first: "Əvvəlcə PDF yükləyin",
    },
    auth: {
      login: "Giriş",
      register: "Qeydiyyat",
      logout: "Çıxış",
      login_title: "Hesabınıza daxil olun",
      register_title: "Yeni hesab yaradın",
      email: "Email",
      password: "Şifrə",
      name: "Ad",
      surname: "Soyad",
      profile: "Profil",
      favorites: "Sevimlilər",
      cart: "Səbət",
      my_account: "Hesabım",
      admin_panel: "Admin paneli",
      no_account: "Hesabınız yoxdur?",
      have_account: "Artıq hesabınız var?",
      welcome: "Xoş gəldiniz",
      password_hint: "Ən azı 6 simvol",
      password_short: "Şifrə ən azı 6 simvol olmalıdır",
      favorites_empty: "Hələ ki sevimliniz yoxdur.",
      customer: "Müştəri",
      role: "Rol",
      remove: "Sil",
    },
    cart: {
      add: "Səbətə əlavə et",
      added: "Səbətə əlavə edildi",
      in_cart: "Səbətdədir",
      empty: "Səbətiniz boşdur.",
      summary: "Səbət yekunu",
      items: "Məhsul",
      total: "Cəmi",
      order_wa: "WhatsApp ilə sifariş",
      wa_greeting: "Salam! Aşağıdakı məhsulları sifariş etmək istəyirəm:",
      wa_note: "Sifariş sorğusu WhatsApp vasitəsilə göndəriləcək. Detalları operatorumuz sizinlə birbaşa razılaşdıracaq.",
      clear: "Səbəti təmizlə",
      confirm_clear: "Səbəti təmizləmək istədiyinizə əminsiniz?",
    },
    footer: { rights: "Bütün hüquqlar qorunur", tagline: "Səliqəli qapı istehsalı" },
    common: { loading: "Yüklənir…", error: "Xəta baş verdi", currency: "AZN" },
  },
  ru: {
    nav: { home: "Главная", catalog: "Товары", pdfs: "PDF каталоги", contact: "Контакты", admin: "Админ" },
    hero: {
      eyebrow: "Friend Doors — Премиум двери",
      title: "Чистая форма. Надёжная дверь.",
      subtitle: "Минималистичная коллекция входных, межкомнатных и офисных дверей. Индивидуальные размеры и материалы.",
      cta_primary: "Смотреть каталог",
      cta_secondary: "Скачать PDF",
    },
    home: {
      featured: "Избранные двери",
      all_products: "Все товары",
      about_label: "О нас",
      about_title: "Тихая форма, точная работа",
      about_body: "Friend Doors производит долговечные двери с архитектурным вкусом. Каждая модель дорабатывается вручную с вниманием к деталям.",
      stats: [
        { k: "12+", v: "лет опыта" },
        { k: "3000+", v: "установленных дверей" },
        { k: "48ч", v: "срок доставки" },
      ],
      cta_title: "Ищете подходящую дверь?",
      cta_body: "Ознакомьтесь с каталогом или скачайте PDF-брошюру.",
    },
    catalog: {
      title: "Товары",
      subtitle: "Все модели нашей коллекции.",
      filter: "Фильтр",
      all: "Все",
      empty: "Нет товаров.",
      view: "Подробнее",
      price_from: "Цена",
    },
    door: {
      material: "Материал",
      dimensions: "Размеры",
      colors: "Цвета",
      category: "Категория",
      order: "Связаться для заказа",
      back: "← Назад",
    },
    categories: { all: "Все", entrance: "Входные двери", interior: "Межкомнатные", bathroom: "Двери для ванной", office: "Офисные двери" },
    pdfs: {
      title: "PDF каталоги",
      subtitle: "Просматривайте в браузере или скачивайте.",
      preview: "Смотреть",
      fullscreen: "На весь экран",
      download: "Скачать",
      open_note: "Просмотр без скачивания",
      empty: "Нет PDF каталогов.",
      close: "Закрыть",
    },
    admin: {
      login_title: "Вход администратора",
      email: "Email",
      password: "Пароль",
      login: "Войти",
      dashboard: "Панель управления",
      logout: "Выйти",
      doors_tab: "Двери",
      catalogs_tab: "PDF каталоги",
      add_door: "Добавить дверь",
      edit_door: "Редактировать",
      add_catalog: "Добавить PDF",
      name: "Название",
      description: "Описание",
      price: "Цена (AZN)",
      category: "Категория",
      material: "Материал",
      dimensions: "Размеры (напр. 90x210 см)",
      colors: "Цвета (через запятую)",
      image: "Изображение",
      upload: "Загрузить",
      save: "Сохранить",
      cancel: "Отмена",
      delete: "Удалить",
      edit: "Изменить",
      confirm_delete: "Удалить?",
      title_field: "Заголовок",
      pdf_file: "PDF файл",
      cover_image: "Обложка",
      cover_help: "Необязательно. Если загрузить, это изображение будет показано как обложка вместо превью PDF.",
      remove: "Удалить",
      edit: "Редактировать",
      no_items: "Нет элементов",
      hero_tab: "Hero-медиа",
      hero_title_section: "Изображение и видео на главной",
      hero_help: "Загрузите изображение и видео. Если есть видео — оно будет проигрываться (без звука, автозапуск, зациклено). Иначе покажется изображение.",
      hero_image: "Hero-изображение",
      hero_video: "Hero-видео",
      upload_image: "Загрузить изображение",
      upload_video: "Загрузить видео",
      no_image: "Изображение не загружено",
      no_video: "Видео не загружено",
      hero_video_note: "Рекомендуется MP4. Держите размер небольшим (в идеале < 20 МБ, петля 10–15 сек).",
      uploaded: "Загружено",
      saved: "Сохранено",
      deleted: "Удалено",
      upload_pdf_first: "Сначала загрузите PDF",
    },
    auth: {
      login: "Войти",
      register: "Регистрация",
      logout: "Выйти",
      login_title: "Вход в аккаунт",
      register_title: "Создать аккаунт",
      email: "Email",
      password: "Пароль",
      name: "Имя",
      surname: "Фамилия",
      profile: "Профиль",
      favorites: "Избранное",
      cart: "Корзина",
      my_account: "Мой аккаунт",
      admin_panel: "Админ-панель",
      no_account: "Нет аккаунта?",
      have_account: "Уже есть аккаунт?",
      welcome: "Добро пожаловать",
      password_hint: "Минимум 6 символов",
      password_short: "Пароль должен быть не менее 6 символов",
      favorites_empty: "У вас пока нет избранного.",
      customer: "Клиент",
      role: "Роль",
      remove: "Удалить",
    },
    cart: {
      add: "В корзину",
      added: "Добавлено в корзину",
      in_cart: "В корзине",
      empty: "Ваша корзина пуста.",
      summary: "Итого",
      items: "Товары",
      total: "Всего",
      order_wa: "Заказ через WhatsApp",
      wa_greeting: "Здравствуйте! Хочу заказать следующие товары:",
      wa_note: "Запрос заказа будет отправлен через WhatsApp. Детали согласует наш оператор.",
      clear: "Очистить корзину",
      confirm_clear: "Очистить корзину?",
    },
    footer: { rights: "Все права защищены", tagline: "Аккуратное производство дверей" },
    common: { loading: "Загрузка…", error: "Произошла ошибка", currency: "AZN" },
  },
  en: {
    nav: { home: "Home", catalog: "Products", pdfs: "PDF Catalogs", contact: "Contact", admin: "Admin" },
    hero: {
      eyebrow: "Friend Doors — Premium Doors",
      title: "Quiet form. Sturdy door.",
      subtitle: "A minimalist collection of entrance, interior and office doors. Every door is crafted with custom sizes and materials.",
      cta_primary: "Browse catalog",
      cta_secondary: "Download PDFs",
    },
    home: {
      featured: "Featured doors",
      all_products: "All products",
      about_label: "About",
      about_title: "Quiet form, precise craft",
      about_body: "Friend Doors builds long-lasting doors with architectural taste. Each model is hand-finished with careful attention to detail.",
      stats: [
        { k: "12+", v: "years experience" },
        { k: "3000+", v: "doors installed" },
        { k: "48h", v: "avg delivery" },
      ],
      cta_title: "Looking for the right door?",
      cta_body: "Explore our catalog or download the PDF brochures.",
    },
    catalog: {
      title: "Products",
      subtitle: "Every model in our collection.",
      filter: "Filter",
      all: "All",
      empty: "No products yet.",
      view: "View",
      price_from: "Price",
    },
    door: {
      material: "Material",
      dimensions: "Dimensions",
      colors: "Colors",
      category: "Category",
      order: "Contact to order",
      back: "← Back",
    },
    categories: { all: "All", entrance: "Entrance doors", interior: "Interior doors", bathroom: "Bathroom doors", office: "Office doors" },
    pdfs: {
      title: "PDF Catalogs",
      subtitle: "Preview in browser or download.",
      preview: "Preview",
      fullscreen: "Fullscreen",
      download: "Download",
      open_note: "View without downloading",
      empty: "No PDF catalogs yet.",
      close: "Close",
    },
    admin: {
      login_title: "Admin login",
      email: "Email",
      password: "Password",
      login: "Sign in",
      dashboard: "Dashboard",
      logout: "Sign out",
      doors_tab: "Doors",
      catalogs_tab: "PDF Catalogs",
      add_door: "Add door",
      edit_door: "Edit door",
      add_catalog: "Add PDF",
      name: "Name",
      description: "Description",
      price: "Price (AZN)",
      category: "Category",
      material: "Material",
      dimensions: "Dimensions (e.g. 90x210 cm)",
      colors: "Colors (comma separated)",
      image: "Image",
      upload: "Upload",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      confirm_delete: "Are you sure?",
      title_field: "Title",
      pdf_file: "PDF file",
      cover_image: "Cover image",
      cover_help: "Optional. If uploaded, this image is shown as the cover instead of the PDF preview.",
      remove: "Remove",
      edit: "Edit",
      no_items: "No items",
      hero_tab: "Hero media",
      hero_title_section: "Home hero image and video",
      hero_help: "Upload an image and a video. If a video is set, it will play (muted, autoplay, looping). Otherwise the image is shown.",
      hero_image: "Hero image",
      hero_video: "Hero video",
      upload_image: "Upload image",
      upload_video: "Upload video",
      no_image: "No image uploaded",
      no_video: "No video uploaded",
      hero_video_note: "MP4 recommended. Keep it small (ideally < 20 MB, 10–15 s loop).",
      uploaded: "Uploaded",
      saved: "Saved",
      deleted: "Deleted",
      upload_pdf_first: "Upload a PDF first",
    },
    auth: {
      login: "Sign in",
      register: "Sign up",
      logout: "Sign out",
      login_title: "Sign in to your account",
      register_title: "Create a new account",
      email: "Email",
      password: "Password",
      name: "Name",
      surname: "Surname",
      profile: "Profile",
      favorites: "Favorites",
      cart: "Cart",
      my_account: "My account",
      admin_panel: "Admin panel",
      no_account: "Don't have an account?",
      have_account: "Already have an account?",
      welcome: "Welcome",
      password_hint: "At least 6 characters",
      password_short: "Password must be at least 6 characters",
      favorites_empty: "You have no favorites yet.",
      customer: "Customer",
      role: "Role",
      remove: "Remove",
    },
    cart: {
      add: "Add to cart",
      added: "Added to cart",
      in_cart: "In cart",
      empty: "Your cart is empty.",
      summary: "Order summary",
      items: "Items",
      total: "Total",
      order_wa: "Order via WhatsApp",
      wa_greeting: "Hello! I would like to order the following items:",
      wa_note: "The order request will be sent via WhatsApp. Our operator will confirm the details with you.",
      clear: "Clear cart",
      confirm_clear: "Clear the cart?",
    },
    footer: { rights: "All rights reserved", tagline: "Quiet, precise door making" },
    common: { loading: "Loading…", error: "An error occurred", currency: "AZN" },
  },
};

const LangCtx = createContext({ lang: "az", setLang: () => {}, t: (k) => k });

export function LangProvider({ children }) {
  const { settings } = useSettings();
  const [lang, setLangState] = useState(() => localStorage.getItem("fd_lang") || "az");
  useEffect(() => {
    localStorage.setItem("fd_lang", lang);
    // Locale-aware CSS text-transform (fixes Azerbaijani i -> İ on uppercase)
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);
  const setLang = (l) => setLangState(l);
  const t = (path) => {
    if (path.startsWith('categories.')) {
      const id = path.slice(11);
      const custom = settings?.categories?.find(c => c.id === id);
      if (custom) return custom[lang] || custom.az || custom.en || id;
    }
    const parts = path.split(".");
    let cur = translations[lang];
    for (const p of parts) {
      if (cur == null) return path;
      cur = cur[p];
    }
    return cur ?? path;
  };
  return <LangCtx.Provider value={{ lang, setLang, t, translations }}>{children}</LangCtx.Provider>;
}

export function useLang() {
  return useContext(LangCtx);
}

export function localized(field, lang) {
  if (!field) return "";
  if (typeof field === "string") return field;
  return field[lang] || field.az || field.en || field.ru || "";
}

export const LANGS = [
  { code: "az", label: "AZ" },
  { code: "ru", label: "RU" },
  { code: "en", label: "EN" },
];
